export default __webpack_public_path__ + "static/media/bg_374833265.8ee13809.webp";